import {
    getStatisticalList,
} from '@/api/sys.statistical'

export default {
    namespaced: true,
    actions: {
        /**
         * 分页查询
         */
        getstatisticalList({
                               dispatch
                           }, {
                               vm,
            data
                           }) {
            return getStatisticalList(data)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        }
    }
}